import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function ExportReportModal({ isOpen, onClose }) {
  const [generating, setGenerating] = useState(false);
  const [generated, setGenerated] = useState(false);

  const handleGenerate = () => {
    setGenerating(true);
    setTimeout(() => {
      setGenerating(false);
      setGenerated(true);
    }, 2000);
  };

  const handleClose = () => {
    setGenerated(false);
    setGenerating(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex: "var(--z-modal)", background: "rgba(15,20,25,0.6)" }}
      onClick={handleClose}
    >
      <div
        className="bg-card border border-border rounded-xl shadow-xl w-full max-w-lg"
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <div className="flex items-center gap-2">
            <Icon name="FileDown" size={18} color="var(--color-primary)" />
            <h2 className="font-heading font-semibold text-foreground" style={{ fontSize: "1.125rem" }}>
              Export Portfolio Report
            </h2>
          </div>
          <button
            onClick={handleClose}
            className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted transition-all"
          >
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="px-6 py-5">
          {!generated ? (
            <>
              <p className="font-caption text-muted-foreground text-sm mb-4">
                Generate a comprehensive portfolio summary report including AUM, SPV performance, ESG metrics, and upcoming milestones.
              </p>
              <div className="space-y-3 mb-5">
                {[
                  "Portfolio overview & AUM summary",
                  "Active SPV performance table",
                  "ESG compliance status",
                  "Upcoming milestones & distributions",
                  "Recent document index",
                ]?.map((item, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <Icon name="CheckCircle" size={15} color="var(--color-success)" />
                    <span className="font-caption text-foreground text-sm">{item}</span>
                  </div>
                ))}
              </div>
              <div className="flex items-center gap-2 p-3 bg-muted rounded-lg mb-5">
                <Icon name="Info" size={15} color="var(--color-secondary)" />
                <p className="font-caption text-muted-foreground text-xs">
                  Report will be generated as PDF. Data as at 05/03/2026.
                </p>
              </div>
              <div className="flex gap-3">
                <Button variant="outline" onClick={handleClose} className="flex-1">
                  Cancel
                </Button>
                <Button
                  variant="default"
                  loading={generating}
                  iconName={generating ? undefined : "FileDown"}
                  iconPosition="left"
                  iconSize={15}
                  onClick={handleGenerate}
                  className="flex-1"
                >
                  {generating ? "Generating…" : "Generate Report"}
                </Button>
              </div>
            </>
          ) : (
            <div className="text-center py-4">
              <div
                className="flex items-center justify-center w-16 h-16 rounded-full mx-auto mb-4"
                style={{ background: "rgba(5,150,105,0.1)" }}
              >
                <Icon name="CheckCircle" size={32} color="var(--color-success)" />
              </div>
              <h3 className="font-heading font-semibold text-foreground mb-2">Report Ready</h3>
              <p className="font-caption text-muted-foreground text-sm mb-5">
                Portfolio_Summary_Report_Mar2026.pdf (1.8 MB)
              </p>
              <div
                className="border border-border rounded-lg p-4 mb-5 text-left"
                style={{ background: "var(--color-muted)" }}
              >
                <div className="flex items-center gap-2 mb-3">
                  <Icon name="FileText" size={16} color="#DC2626" />
                  <span className="font-caption font-semibold text-foreground text-sm">
                    Portfolio Summary Report — March 2026
                  </span>
                </div>
                <div className="space-y-1.5">
                  {["AUM: £2.47B", "Active SPVs: 8", "Net IRR: 11.3%", "ESG Score: 82/100"]?.map((line) => (
                    <p key={line} className="font-data text-muted-foreground text-xs">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
              <div className="flex gap-3">
                <Button variant="outline" onClick={handleClose} className="flex-1">
                  Close
                </Button>
                <Button
                  variant="default"
                  iconName="Download"
                  iconPosition="left"
                  iconSize={15}
                  onClick={handleClose}
                  className="flex-1"
                >
                  Download PDF
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}